import React from 'react';

import { CONTACT } from 'constants/texts';
import { SECTIONS } from 'constants/sections';

import Button from 'components/Button';
import Section from 'components/Section';
import Field from 'components/Field';

import './styles.scss';

function Contact() {
  return (
    <Section name={SECTIONS.CONTACT.name}>
      <div className="first-column">
        <h2 className="title">{CONTACT.title}</h2>
        <form className="contact-form">
          <Field className="contact-form__input" name="name" label="Your name" />
          <Field className="contact-form__input" name="email" type="email" label="Your email" />
          <Field className="contact-form__text-area" component="textarea" name="project" type="text" label="About your project" />
          <Button className="contact-form__button" type="submit">Send</Button>
        </form>
      </div>
      <p className="hint">More ways to connect</p>
    </Section>
  )
}

export default Contact;
